export const enum SecurityDataTestId {
    MfaCard = 'MfaCard',
    ScimCard = 'ScimCard',
    SecurityCardSkeleton = 'SecurityCardSkeleton',
    SecurityFeaturesActivated = 'SecurityFeaturesActivated',
    SecurityLevelTips = 'SecurityLevelTips',
    SsoCard = 'SsoCard',
    TooManyAdminUsersTooltip = 'TooManyAdminUsersTooltip',
    TrustedDeviceAuthCard = 'TrustedDeviceAuthCard',
    UserAccountsSecured = 'UserAccountsSecured',
    UsersLoggedInWithPasskeys = 'UsersLoggedInWithPasskeys',
    UsersWithAdminAccess = 'UsersWithAdminAccess',
}
